/**
 *
 */

import React, { useState, useEffect } from "react";

/* Import configuration starts */
import moment from "moment";
import GLOBAL from "../../../../../setup/constants/global";
import { useNavigate, useLocation } from "react-router";
import { pathNamePopped } from "../../../../../setup/utils/global-helper";
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
import { Table } from "react-bootstrap";
/* Import react bootstrap component ends */

/* Import image and SVG starts */
import { EyeFilledBlue } from "../../../../../setup/constants/images";
/* Import image and SVG ends */

/* Import local pages and component starts */
/* Import local pages and component ends */

/* Component starts */
const MoveIn = (props) => {
  /* Props destructuring starts */
  const { index, maintenance } = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  const navigate = useNavigate();
  const { pathname } = useLocation();
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  const USER_DATA = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;
  const DATE_FORMAT = USER_DATA ? USER_DATA?.date_format : "";
  const TIME_FORMAT = USER_DATA ? USER_DATA?.time_format : "";
  const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="move-wrapper">
      <div className="move-heading">
        <p className="font_l label"> {index && `${index} -`} Move In</p>
      </div>

      {/* ID Verfication Table */}
      <div className="custom-table-wrapper">
        <Table className="custom-table font_s" borderless responsive>
          {/* Table Heading */}
          <thead>
            <tr>
              <th></th>
              <th>Maintenance</th>
              {maintenance?.status && <th></th>}
              <th>Action Date</th>
            </tr>
          </thead>
          {/* Table Body */}
          <tbody>
            <tr>
              <td>Move In</td>
              <td>
                {!maintenance?.status && <p className="font_m">Not Assigned</p>}
                {maintenance?.status && (
                  <p
                    className={` ${
                      maintenance?.status === "New"
                        ? "font_blue"
                        : maintenance?.status === "Completed"
                        ? "font_green"
                        : "font_yellow"
                    } font_m`}
                  >
                    {maintenance?.status}
                  </p>
                )}
              </td>
              {maintenance?.status && (
                <td>
                  <img
                    src={EyeFilledBlue}
                    onClick={() => {
                      const newPathName = pathNamePopped(pathname, 3);
                      navigate(
                        `${newPathName}/maintenances/Move%20In/${maintenance?._id}`,
                        { state: { pathname: pathname } }
                      );
                    }}
                    alt=""
                    className="icon_m"
                  />
                </td>
              )}

              <td>{moment(maintenance?.updatedAt).format(DATE_TIME_FORMAT)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};
/* Component ends */

export default MoveIn;
